let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3SSQy")).then(() => parcelRequire('1mzMT'));